module.exports = __webpack_public_path__ + "img/Icon awesome-linkedin-in.ba7aedc6.svg";